import React from 'react';
import { products } from '../../data/products';
import Hero from '../../components/Hero';
import ProductCard from '../../components/ProductCard';

const Routers = () => {
  const routers = products.filter(product =>
    product.name.toLowerCase().includes('router') ||
    product.name.toLowerCase().includes('mesh')
  );

  return (
    <>
      <Hero
        title="Routere și Sisteme Mesh"
        subtitle="Echipamente performante pentru rețeaua ta wireless"
        backgroundImageUrl="/img/hero-cat-routers.jpg"
      />
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {routers.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Routers;
